import script from "./TrainMode.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainMode.vue?vue&type=script&setup=true&lang=js"

import "./TrainMode.vue?vue&type=style&index=0&id=08ab9273&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08ab9273"]])

export default __exports__